import React from 'react';
import { isArray, Date2String } from "../dependency/UtilityFunctions";
import {ReactHtmlParser, convertNodeToElement,
  processNodes} from 'react-html-parser';
import Button from '../components/common/Button'

export const homeworkListModel = (arg) => {
  const { data } = arg;
  function transform(node, index) {
      
    // all links must open in a new window
    if (node.type === "tag" && node.name === "a") {
      node.attribs.target = "_blank";
      return convertNodeToElement(node, index, transform);
    }
  
    if (node.type === "tag" && node.name === "button") {
      return (
        <Button key={index}>
          {processNodes(node.children, transform)}
        </Button>
      );
    }
  } 
    
  const HtlmParserOptions = {
    decodeEntities: true,
    transform
  };

  // console.log(data);
  if (!isArray(data)) return [];

  let res = [];
  data.forEach((item, id) => {
    let dateArray = item.duedate.split("/");
    let newdate = dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0];
    // console.log(newdate);
    res.push({
      id,
      ...item,

      class: item.class,
      subject: item.subjectname,
      date: item.duedate,
      date: Date2String(newdate, true),
      time: item.timeagooo,
      assignment: item.assignment,

      // assignment: item.assignment

    });
  });
  return [res,];
};
export const vitualClassListModel = (arg) => {
  const { data } = arg;
  if (!isArray(data)) return [];

  let res = [];
  data.forEach((item, id) => {
    let datetimex = item.datetimex;
    let dateArray = datetimex.split("T");
    let dateString = Date2String(dateArray[0], true);
    res.push({
      id,
      // ...item,

      subject: item.topicx,
      date: dateString,
      time: dateArray[1],
      duration: `${item.durationx} min`,
      classLink: item.url

    });
  });
  return [res,];
};


// classx: "JSS 2 A"

// datetimex: "2020-11-05T10:25"

// durationx: "60"

// idx: "2174"

// invitees: "EDVESSSSSSS"

// owner: "Arogunyo"

// schooluniqueidx: "30"

// subject: ""

// termx: "FIRST TERM"

// topicx: "Stochiometry"

// url: "https://us04web.zoom.us/j/7794196076?pwd=R3Evc0QyV211dUhhdG5hamZXTTF0dz09"

// yearx: "2020/2021"